<div class="marketing-hero-container" [dir]="documentDir">
  <img
    *ngFor="let image of processedTiles; let index = index"
    osnSharedUseAsPicture
    class="background-image"
    [class.visible-image]="position === index"
    [src]="image.fallbackUrl"
    [imgQuery]="image.imgQuery"
    [alt]="image.title"
  />
  <div class="blur-layer"></div>
  <div class="darken-layer"></div>
  <button *ngIf="showNavigationArrows" class="arrow-icon left" (click)="onSelectTile(position - 1)">
    <svg-icon key="left" size="md"></svg-icon>
  </button>
  <button *ngIf="showNavigationArrows" class="arrow-icon right" (click)="onSelectTile(position + 1)">
    <svg-icon key="right" size="md" class="svg-icon-right"></svg-icon>
  </button>
  <div class="content-container">
    <div class="swiper-wrapper">
      <swiper
        [dir]="documentDir"
        *osnRerenderOnDirectionChange
        [slidesPerView]="1"
        [spaceBetween]="0"
        [index]="position"
        (paginationUpdate)="onSelectTile($any($event).activeIndex)"
        [pagination]="{
          clickable: true
        }"
      >
        <ng-template swiperSlide *ngFor="let tile of processedTiles">
          <div class="text-container">
            <span class="title">{{ tile.title | replacePriceAndCurrency: vm.subscriptionPrice:vm.currency }}</span>
            <span class="description">{{ tile.description | replacePriceAndCurrency: vm.subscriptionPrice:vm.currency }}</span>
          </div>
        </ng-template>
      </swiper>
    </div>
    <button [osnSharedMarketingActionButton]="vm.button" class="cta-button" (click)="onButtonClick()">{{ buttonText }}</button>
  </div>
</div>
